import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { map, Observable } from 'rxjs';
import { ROUTE_NAMES } from '@brc/route-names';
import { Permission } from '@shared/models';
import { isAdmin } from '@shared/helpers';
import { OrganizationsStore } from '@shared/state';

// UX-only: hides the route from non-admins. Backend authorization must still enforce feedback data access.
export const MlValidationFeedbacksGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const router = inject(Router);
  const organizationsStore = inject(OrganizationsStore);

  return toObservable(organizationsStore.permission).pipe(
    map((permission: Permission | undefined): boolean | UrlTree =>
      permission !== undefined && isAdmin(permission) ? true : router.createUrlTree([ROUTE_NAMES.ROOT])
    )
  );
};
